import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
const apiurl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class AppAlertService {
  constructor(private readonly http: HttpClient, private readonly errorHandler: ErrorHandlerService,) { }
  createItem(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/appalerts`, data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }
  getItems(param: HttpParams = null): Observable<any> {
    return this.http.get<any>(`${apiurl}/appalerts`, { params: param }).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  updateItem(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/appalerts/update/${data.id}`, data).pipe(
      tap((response) => response)
    );
  }
  deleteItem(data: any): Observable<any> {
    return this.http.post<any>(`${apiurl}/appalerts/delete/${data.deleted_id}`, data).pipe(
      tap((response) => response)
    );
  }
}
